import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import LogoCarousel from '@segment/templates/LogoCarousel'
import { carouselLogos } from '@segment/templates/LogoCarousel/data'

const copy = {
  heading: `Fast-growing marketplaces choose Segment`,
}

const logos = [
  carouselLogos.INSTACART,
  carouselLogos.APARTMENT_LIST,
  carouselLogos.DOORDASH,
  carouselLogos.DELIVEROO,
  carouselLogos.LENDING_TREE,
  carouselLogos.HOTEL_TONIGHT,
]

const LogoCarouselComponent = () => {
  return (
    <StyledSectionBase variant="noCopy">
      <Section.Contents>
        <LogoCarousel heading={copy.heading} logos={logos} />
      </Section.Contents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 20px;

    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      padding-top: 40px;
    }
  }
`

export default LogoCarouselComponent
